<template>
  <b-modal
    id="holidays-modal"
    ref="modal"
    v-model="visible"
    :title="title"
    @hidden="hide"
    @shown="onShow"
    size="lg"
  >
    <ValidationObserver
      @submit.prevent="onSubmit"
      ref="holidaysForm"
      tag="form"
      id="holidaysForm"
    >
      <!-- Pracownik -->
      <b-form-group
        label-cols-lg="3"
        label="Pracownik:"
        label-for="employee-name"
        label-align-lg="right"
        v-if="isAdmin"
      >
        <ValidationProvider
          name="employee-name"
          rules="required"
          v-slot="validationContext"
        >
          <b-form-select
            id="employee"
            label="name"
            track-by="id"
            :options="availableEmployees('onlyActive')"
            v-model="form.user_id"
            :multiple="false"
          ></b-form-select>
          <b-form-invalid-feedback :force-show="true"
            >&nbsp;{{ validationContext.errors[0] }}</b-form-invalid-feedback
          >
        </ValidationProvider>
      </b-form-group>
      <b-form-group
        label-cols-lg="3"
        label="Pracownik:"
        label-for="employee-name"
        label-align-lg="right"
        v-else
      >
        <input class="form-control" type="text" readonly :value="getFullName" />
        <input type="hidden" readonly v-model="form.user_id" />
      </b-form-group>
      <b-form-group
        label-cols-lg="3"
        label="Rodzaj:"
        label-for="holiday-category"
        label-align-lg="right"
      >
        <ValidationProvider
          name="holiday-category"
          rules="required"
          v-slot="validationContext"
        >
          <b-form-select
            id="category"
            placeholder
            label="name"
            track-by="id"
            :options="category"
            v-model="form.type"
            :multiple="false"
          ></b-form-select>
          <b-form-invalid-feedback :force-show="true"
            >&nbsp;{{ validationContext.errors[0] }}</b-form-invalid-feedback
          >
        </ValidationProvider>
      </b-form-group>

      <b-form-group
        label-cols-lg="3"
        label="Data rozpoczęcia:"
        label-for="start-date"
        label-align-lg="right"
      >
        <ValidationProvider
          name="start-date"
          rules="required"
          v-slot="validationContext"
        >
          <div style="max-width: 200px">
            <v-date-picker
              v-model="form.start"
              :masks="{ input: 'YYYY-MM-DD' }"
              :popover="{ visibility: 'click' }"
              :min-date="vcalendar.mindate"
            ></v-date-picker>
          </div>
          <b-form-invalid-feedback :force-show="true"
            >&nbsp;{{ validationContext.errors[0] }}</b-form-invalid-feedback
          >
        </ValidationProvider>
      </b-form-group>

      <b-form-group
        label-cols-lg="3"
        label="Data zakończenia:"
        label-for="end_date"
        label-align-lg="right"
      >
        <ValidationProvider
          name="end_date"
          rules="required"
          v-slot="validationContext"
        >
          <div style="max-width: 200px">
            <v-date-picker
              v-model="form.end"
              :masks="{ input: 'YYYY-MM-DD' }"
              :popover="{ visibility: 'click' }"
              :min-date="vcalendar.mindate"
              readonly
            ></v-date-picker>
          </div>
          <b-form-invalid-feedback :force-show="true"
            >&nbsp;{{ validationContext.errors[0] }}</b-form-invalid-feedback
          >
        </ValidationProvider>
      </b-form-group>

      <b-form-group
        label-cols-lg="3"
        label="Notatka:"
        label-for="note"
        label-align-lg="right"
      >
        <ValidationProvider name="end-date" v-slot="validationContext">
          <template>
            <div>
              <b-form-textarea
                id="note"
                v-model="form.description"
                rows="6"
                max-rows="6"
                placeholder="Wpisz notke..."
              ></b-form-textarea>
            </div>
          </template>
          <b-form-invalid-feedback :force-show="true"
            >&nbsp;{{ validationContext.errors[0] }}</b-form-invalid-feedback
          >
        </ValidationProvider>
      </b-form-group>
    </ValidationObserver>
    <template v-slot:modal-footer="{ cancel }">
      <b-button size="md" variant="primary" type="submit" form="holidaysForm"
        >Zapisz</b-button
      >
      <b-button size="md" variant="outline-danger" @click="cancel()"
        >Anuluj</b-button
      >
    </template>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import HolidaysService from "@/services/holidays.service";
import dayjs from "dayjs";

export default {
  name: "ModalHolidays",
  components: {},
  props: {
    event: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      editedItem: null,
      isBusy: false,
      visible: false,
      selected_employee: null,
      selected_category: null,
      isEdited: false,
      category: [
        { value: "holiday", text: "urlop" },
        { value: "sickness", text: "chorobowe" },
        { value: "other", text: "inne" },
      ],
      start_date_model: "",
      end_date_model: "",
      form: {
        user_id: "",
        start: "",
        end: "",
        type: "",
        description: "",
      },
      vcalendar: {
        mindate: null,
      },
    };
  },
  computed: {
    ...mapGetters("user", ["isAdmin", "getFullName"]),
    ...mapGetters("app", ["availableEmployees"]),
    title() {
      return this.isEdited ? "Edytuj urlop" : "Dodaj nowy urlop";
    },
  },
  methods: {
    ...mapActions("app", ["loadAvailableEmployees"]),
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    hide() {
      this.$_.each(this.form, (value, key) => {
        this.form[key] = "";
      });
    },
    onShow() {
      this.isEdited = this.$_.isEmpty(this.event.id) === false;
      if (this.isEdited) {
        this.form.user_id = this.event.user_id;
        this.form.start = new Date(this.event.start);
        this.form.end = new Date(this.event.end);
        this.form.type = this.event.type;
        this.form.description = this.event.description;
      }
      if (this.isAdmin) {
        this.loadAvailableEmployees();
        this.vcalendar.mindate = null;
      } else {
        this.vcalendar.mindate = new Date();
      }
    },
    onSubmit() {
      this.$refs.holidaysForm.validate().then((success) => {
        if (!success) {
          return;
        }
        let query = this.copyForm();
        this.$Progress.start();
        if (this.isEdited) {
          //   //-- EDITED
          HolidaysService.update(this.event.id, query)
            .then((data) => {
              this.$emit("onUpdate", data);
              this.$nextTick(() => {
                this.$bvModal.hide("holidays-modal");
              });
            })
            .catch((error) => {
              this.$refs.holidaysForm.setErrors(error.response.data.fields);
            });
        } else {
          //-- CREATE NEW
          HolidaysService.create(query)
            .then((data) => {
              this.$emit("onSubmit", data);
              this.$nextTick(() => {
                this.$bvModal.hide("holidays-modal");
              });
            })
            .catch((error) => {
              this.$refs.holidaysForm.setErrors(error.response.data.fields);
            });
        }
      });
    },
    copyForm() {
      let query = {};
      this.$_.forEach(this.form, (item, key) => {
        if (key === "start" || key === "end") {
          query[key] = dayjs(item).format("YYYY-MM-DD");
        } else {
          query[key] = item;
        }
      });
      return query;
    },
  },
};
</script>
